export const BRAND = {
  name: "JE Training",
  tagline: "Strength — Togetherness",
  phone: "07376 030893",
  phoneHref: "tel:+447376030893",
  email: "je.training@aol.com",
  emailHref: "mailto:je.training@aol.com",
  location: "Braintree, Essex",
  instagram: "https://www.instagram.com/jetraining_",
  facebook: "https://www.facebook.com/share/1boxxyr4xy/",
  logo: "https://customer-assets.emergentagent.com/job_24bc98a8-5975-477a-89fd-447a6fe19363/artifacts/k6ia7w2m_IMG_6624.png",
};

export const SERVICES = [
  {
    id: "1-2-1",
    title: "1-2-1 Sessions",
    short: "Private Coaching",
    description:
      "Fully personalised one-to-one training built entirely around your goals, schedule and ability. Undivided focus, faster results.",
    highlights: ["Personalised programming", "Form & technique coaching", "Accountability"],
  },
  {
    id: "2-2-1",
    title: "2-2-1 Sessions",
    short: "Partner Training",
    description:
      "Train with a friend or partner. Shared motivation, shared cost, same elite coaching — built for two.",
    highlights: ["Paired programming", "Healthy competition", "Better value"],
  },
  {
    id: "group",
    title: "3+ Small Group",
    short: "Pack Training",
    description:
      "High-energy small group sessions (3+). The community of a class with the attention of a coach.",
    highlights: ["Small numbers", "Team atmosphere", "Strength & conditioning"],
  },
  {
    id: "nutrition",
    title: "Nutritional Guidance",
    short: "Fuel The Work",
    description:
      "Sustainable nutrition coaching that complements your training — no fads, no crash diets, just real strategies that stick.",
    highlights: ["Habit-based", "Macros made simple", "Ongoing support"],
  },
  {
    id: "senior",
    title: "Senior Rehabilitation",
    short: "Move Well, Live Well",
    description:
      "Safe, measured training for older adults focused on mobility, stability and everyday strength. Regain confidence in how you move.",
    highlights: ["Low-impact", "Mobility-first", "Confidence building"],
  },
  {
    id: "kids",
    title: "Kids Sessions",
    short: "Next Generation",
    description:
      "Fun, age-appropriate sessions that build movement literacy, coordination and confidence in young athletes.",
    highlights: ["Playful & safe", "Coordination", "Confidence"],
  },
];
